import React from 'react';
import { WebContent } from 'js/components/system/WebContent';
import { componentService } from 'js/services/component.service';
import { useAppSelector, useDeviceSelector } from 'js/store/hooks';

import style from './AboveHeader.scss';

export const AboveHeader = () => {
    const { aboveHeaderWcIdDesktop, aboveHeaderWcIdTablet, aboveHeaderWcIdMobile } = useAppSelector();
    const { formFactor } = useDeviceSelector();
    const wcID = {
        desktop: aboveHeaderWcIdDesktop,
        tablet: aboveHeaderWcIdTablet,
        mobile: aboveHeaderWcIdMobile
    }[formFactor];

    if (wcID) {
        return (
            <div className={style.container}>
                <WebContent id={wcID} />
            </div>
        );
    }

    return null;
};

componentService.registerWebContentComponents({ AboveHeader });
